/* eslint-disable camelcase */
import React, { useState } from "react";
import { ReactComponent as MapIcon } from "./../../images/svg/map.svg";
// eslint-disable-next-line
import { gettext } from "../../adapter";
import WeatherDataMap from "./WeatherDataMap";
import moment from "moment";
import Select from "react-select";
import { useDispatch } from "react-redux";
import weatherStationsActions from "./../../actions/weatherStationsActions";

const WeatherDataStations = ({ stations, selectedStation, fetchPeriod, apiUrl }) => {
  const dispatch = useDispatch();
  var activestations = "";
  var inactivestations = "";
  var showSubHeader;
  var this_year = moment().year();

  const [mapOpen, setMapOpen] = useState(false);

  showSubHeader = Boolean(
    stations.find(function (station) {
      return station.year !== this_year;
    })
  );

  var list = "";
  if (stations.length < 4 && !showSubHeader) {
    activestations = stations.map(function (station) {
      var handleClick = function () {
        dispatch(
          weatherStationsActions.selectFetchStation(
            apiUrl,
            station.id,
            station.showAllMeasurements,
            station.showFiveMinutesMeasurements,
            fetchPeriod
          )
        );
      };

      if (station.id === selectedStation.id) {
        return (
          <li className="is-selected" key={station.id}>
            {/* eslint-disable-next-line */}
            <a onClick={handleClick}>{station.name}</a>
          </li>
        );
      } else {
        return (
          <li key={station.id}>
            {/* eslint-disable-next-line */}
            <a onClick={handleClick}>{station.name}</a>
          </li>
        );
      }
    });
    list = <ul>{activestations}</ul>;
  } else {
    activestations = stations.reduce(function (result, station) {
      if (station.year === this_year) {
        result.push({
          value: station.id,
          label: station.name,
          showFiveMinutesMeasurements: station.showFiveMinutesMeasurements,
          showAllMeasurements: station.showFiveMinutesMeasurements,
        });
      }
      return result;
    }, []);
    inactivestations = stations.reduce(function (result, station) {
      if (station.year !== this_year) {
        var name = station.year + ": " + station.name;
        result.push({ value: station.id, label: name });
      }
      return result;
    }, []);
    const groupedOptions = [
      { label: gettext("Active stations"), options: activestations },
      { label: gettext("Inactive stations"), options: inactivestations },
    ];

    const selectedValue = groupedOptions
      .flatMap((group) => group.options)
      .find((option) => option.value === selectedStation.id);

    list = (
      <Select
        value={selectedValue}
        options={groupedOptions}
        className="react-select-container"
        classNamePrefix="react-select"
        noOptionsMessage={(input) => gettext("No results for") + ' "' + input.inputValue + '"'}
        onChange={(selected) => {
          dispatch(
            weatherStationsActions.selectFetchStation(
              apiUrl,
              selected.value,
              selected.showAllMeasurements,
              selected.showFiveMinutesMeasurements,
              fetchPeriod
            )
          );
        }}
      />
    );
  }
  var mapButton = (
    <div className="viewswitch">
      {/* eslint-disable-next-line */}
      <a
        onClick={() => {
          setMapOpen(!mapOpen);
        }}
        className={mapOpen ? "is-selected" : ""}
      >
        <MapIcon className="icon is-inline" />
        {gettext("Map")}
      </a>
    </div>
  );
  var map = "";
  if (mapOpen) {
    map = (
      <WeatherDataMap
        apiUrl={apiUrl}
        stations={stations}
        selectedStation={selectedStation}
        closeMap={() => {
          setMapOpen(false);
        }}
      />
    );
  }

  return (
    <div>
      <div className="tabs l-full text-center">
        {list}
        {mapButton}
      </div>
      {map}
    </div>
  );
};

export default WeatherDataStations;
